// extracted by mini-css-extract-plugin
export default {"formBox":"login_formBox__FBW4c","btn":"login_btn__MtXiV","input":"login_input__gYSar","header":"login_header__+eic0","inputWrapper":"login_inputWrapper__3swSH"};